import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, input, Output } from '@angular/core';
import { NovaIcon } from '@rds-nova/angular-icon';
import { TranslatePipe } from '@ngx-translate/core';
import { FaqQaListComponent, QaItem } from '../faq-qa-list/faq-qa-list.component';
import { forkJoin } from 'rxjs';
import { LocalChatService } from 'src/app/features/help-faq/services/local-chat.service';
import { ChatResponse } from 'src/app/features/help-faq/models/chat.models';

export type { QaItem };

export interface FaqRootItem {
    title: string;
    targetNodeId: string;
}

@Component({
    selector: 'app-faq-window',
    standalone: true,
    imports: [CommonModule, NovaIcon, TranslatePipe, FaqQaListComponent],
    templateUrl: './faq-window.component.html',
    styleUrl: './faq-window.component.scss',
})
export class FaqWindowComponent {
    private readonly chatService = inject(LocalChatService);

    items = input<FaqRootItem[]>([]);

    @Output() closed = new EventEmitter<void>();

    expandedIndex: number | null = null;
    questionsMap = new Map<number, QaItem[]>();
    loadingSet = new Set<number>();

    toggle(item: FaqRootItem, index: number): void {
        const isOpening = this.expandedIndex !== index;
        this.expandedIndex = isOpening ? index : null;

        if (isOpening && !this.questionsMap.has(index)) {
            this.loadingSet.add(index);
            this.chatService.selectOption({ nodeId: item.targetNodeId }).subscribe({
                next: (response: ChatResponse) => {

                    if (response.isDynamic) {
                        this.questionsMap.set(index, [{ question: '', answer: response.message }]);
                        this.loadingSet.delete(index);
                        return;
                    }

                    forkJoin(
                        response.options.map(opt =>
                            this.chatService.selectOption({ nodeId: opt.targetNodeId })
                        )
                    ).subscribe({
                        next: (answers: ChatResponse[]) => {
                            this.questionsMap.set(index, response.options.map((opt, i) => ({
                                question: `help-faq.questions.${opt.targetNodeId}`,
                                answer: answers[i].message,
                            })));
                            this.loadingSet.delete(index);
                        },
                    });
                },
            });
        }
    }

    isExpanded(index: number): boolean {
        return this.expandedIndex === index;
    }

    isLoading(index: number): boolean {
        return this.loadingSet.has(index);
    }

    getQuestions(index: number): QaItem[] {
        return this.questionsMap.get(index) ?? [];
    }

  resolveLabel(item: FaqRootItem): string {
    return `help-faq.faqCategories.${item.targetNodeId}`;
  }
}
